'use client'

import { useEffect } from 'react'
import { useServerStateSummary } from 'actions/serverStateSummary'
import ServerStateCard, { ServerStateCardSkeleton } from 'atoms/ServerStateCard'

export default function DynamicServerStateCard() {
  const { serverStateSummary, isError, error, refetch } = useServerStateSummary()

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 10000)

    return function cleanUp() {
      clearInterval(interval)
    }
  }, [refetch])

  if (isError || serverStateSummary instanceof Error) return <p>Error: {error?.message}</p>
  if (!serverStateSummary) return <ServerStateCardSkeleton />

  return <ServerStateCard serverStateSummary={serverStateSummary} />
}
